import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { IUserPreferences } from 'src/models/interfaces/userPreferences';
import userPreferencesService from 'src/service/userPreferences';

export const UserPreferencesContext = createContext({} as {
  items: IUserPreferences<any>[],
  update: (item: IUserPreferences<any>) => void;
  get: (key: string) => IUserPreferences<any> | undefined;
  getCols: (key: string) => string[];
});

export const UserPreferencesProvider = (props: any) => {
  const [items, setItems] = useState<IUserPreferences<any>[]>([]);

  useEffect(() => {
    userPreferencesService.get()
      .then(({ data }) => {
        const items = data.data
        let pref: { key: string, data: any }[] = [];

        for (var p in items) pref.push({ key: p, data: items[p] });
        setItems(pref);
      });
  }, []);

  const update = useCallback(({ key, data }) => {
    let pref = items ? [...items] : [];
    const index = pref.findIndex(p => p.key === key);

    pref.splice(index, 1, { key, data });
    setItems(pref);
  }, [items]);

  const get = useCallback((key: string) => {
    return items.find(i => i.key === key);
  }, [items]);

  const getCols = useCallback((key: string) => {
    const items = get(key);

    if (items)
      return (items as IUserPreferences<string[]>).data.filter(d => ['country', 'state', 'city'].includes(d));

    return [];
  }, [items]);

  return (
    <UserPreferencesContext.Provider value={{ items, update, get, getCols }}>
      {props.children}
    </UserPreferencesContext.Provider>
  );
};

const useUserPreferences = () => useContext(UserPreferencesContext);
export default useUserPreferences;